<template lang="html">

    <div class="wrapper margin-menu">
  
      <section class="intro column-center -proyectos-finalizados">
        <h2>Agua para todos</h2>
        <h1>Proyectos conseguidos</h1>
      </section>
  
      <section class="breadcrumb">
        <nav class="container row-end">
          <router-link to="/">Inicio</router-link>
          <router-link :to="$t('enlaces.aguaparatodos')">Agua para todos</router-link>
          <router-link :to="$t('enlaces.proyectosfinalizados')">Proyectos conseguidos</router-link>
        </nav>
      </section>
  
      <main>
  
        <div class="container">
  
          <h2 class="title-intro">
            <img src="/static/img/logo-agua-para-todos.png" alt="Logo agua para todos">
          </h2>
  
        </div>
  
  
        <section class="white-box objetivo-agua-para-todos">
          <div class="container row-start">
            <h2 class="big-title">Proyectos</h2>
          </div>
          <div class="title-container row-end">
            <h3 class="title-destacado -azul">Proyectos que hemos conseguido gracias a donaciones.</h3>
          </div>
  
        </section>
  
  
        <section class="contenedor-proyectos-en-curso row-start container">
  
          <proyecto :key="key" :project="project" v-for="(project,key) in projectsFinish"></proyecto>
    
        </section>
  

  
  
      </main>
  
    </div>
  
  
  </template>
  
  <script lang="js">
  
  import {mapActions, mapGetters} from 'vuex'
  
  import proyecto from '@/components/parts/proyecto';
  
  
  export default {
    name: 'proyectos-en-curso',
    mounted(){
      this.requestProyectos();
    },
    methods: {
      ...mapActions(['requestProyectos']),
    },
    computed : {
      ...mapGetters({
        projectsNotfinish : 'getProjectsNotfinish',
        projectsFinish : 'getProjectsfinish'
      })
    },
    components : {
      'proyecto' : proyecto,
    }
  }
    
  </script>
  
  
  <style lang="scss">
  
  </style>
  
  
  
  
  
  


// WEBPACK FOOTER //
// src/components/views/proyectos-finalizados.vue